export interface ChildrenValidationResult {
  isValid: boolean;
  message?: string;
  count: number;
  formattedSexes: string;
}

const parseChildrenSexes = (childrenSexes?: string) =>
  (childrenSexes || "")
    .split(/[\s,]+/)
    .map((sex) => sex.trim())
    .filter(Boolean);

export const validateAndFormatChildrenDetails = (
  childrenCountInput: any,
  childrenSexes?: string
): ChildrenValidationResult => {
  const count = Number(childrenCountInput ?? 0);

  if (Number.isNaN(count) || count < 0) {
    return {
      isValid: false,
      message: "Children count must be zero or a positive number.",
      count: 0,
      formattedSexes: "",
    };
  }

  const parsedSexes = parseChildrenSexes(childrenSexes);

  if (count === 0) {
    if (parsedSexes.length > 0) {
      return {
        isValid: false,
        message: "Remove children sexes when children count is zero.",
        count,
        formattedSexes: "",
      };
    }

    return {
      isValid: true,
      count,
      formattedSexes: "",
    };
  }

  if (parsedSexes.length !== count) {
    return {
      isValid: false,
      message: `Children sexes entries (${parsedSexes.length}) must match children count (${count}).`,
      count,
      formattedSexes: parsedSexes.join(", "),
    };
  }

  return {
    isValid: true,
    count,
    formattedSexes: parsedSexes.join(", "),
  };
};
